import { Row } from "@tanstack/react-table";

import { Button } from "@/components/ui/button/button";
import { useSalaryModal } from "../salary-modal/use-salary-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as {
    approved: boolean;
    employee: {
      _id: string;
      name: string;
      email: string;
    };
    createdAt: string | Date;
    netPay: number;
    totalEarnings: number;
    totalDeductions: number;
    notes: string;
    period: string;
    components: {
      type: string;
      amount: number;
      name: string;
      description: string;
    }[];
    id: string;
  };

  const { setSalary, onOpenChange } = useSalaryModal();

  return (
    <div className="flex items-center gap-4">
      <Button
        size="sm"
        variant="outline"
        onClick={() => {
          setSalary(originData);
          onOpenChange(true);
        }}
      >
        View
      </Button>
    </div>
  );
}
